export default "/_nuxt/ca3cea263f9401a2b3e199eab360a5ae.svg";